import { _ } from '../type';
import { pipe } from 'fp-ts/function';
export const scene = (r) => pipe(r, _.unwrap, _r => _r.scene);
